import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Education } from '../../models/education.model';
import { EducationMockService } from '../../services/education-mock.service';

@Component({
  selector: 'bwc-education-detail',
  templateUrl: './education-detail.component.html',
  styleUrls: ['./education-detail.component.scss'],
})
export class EducationDetailComponent implements OnInit {
  education: Education | undefined;
  isExpanded = false;
  isSaved = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private educationService: EducationMockService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = Number(params['id']);
      this.educationService.getEducationById(id).subscribe(e => {
        this.education = e;
        this.isSaved = e ? this.educationService.getSavedIds().includes(e.id) : false;
        this.isExpanded = false;
      });
    });
  }

  get displayedDescription(): string {
    if (!this.education?.description) return '';
    if (this.isExpanded) return this.education.description;
    return this.education.description.length > 800
      ? this.education.description.slice(0, 800) + '...'
      : this.education.description;
  }

  get canExpand(): boolean {
    return !!this.education?.description && this.education.description.length > 800;
  }

  toggleSave(): void {
    if (this.education) {
      this.isSaved = this.educationService.toggleSaveEducation(this.education);
    }
  }

  goBack(): void {
    this.router.navigate(['/profile-check/educations']);
  }
}
